<template>
  <v-row>
    <v-col cols="12" lg="7" xl="6" class="info d-none d-md-flex align-center justify-center">
      <v-container>
        <div class="pa-10">
          <v-row justify="center">
            <v-col cols="8" xl="5">
              <div>
                <h2
                  class="display-1 white--text font-weight-medium"
                >Left Content Title - TODO</h2>
                <h6
                    class="subtitle-1 mt-4 white--text op-5 font-weight-regular"
                >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Asperiores autem consequatur dolorem eum excepturi, modi neque, nisi non omnis quam quas qui quis quo reiciendis sint tempore veritatis voluptas, voluptate!
                </h6>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-col>
    <v-col cols="12" lg="9" xl="6" class="d-flex align-center">
      <v-container>
        <div class="pa-7 pa-sm-12">
          <v-row>
            <v-col cols="12" lg="9" xl="6">
              <img src="@/assets/logo.png" alt="">
              <h2 class="font-weight-bold mt-4 blue-grey--text text--darken-2">Sign in</h2>

              <v-form ref="form" lazy-validation @submit="submitLogIn">
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="E-mail"
                  class="mt-4"
                  required
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  :rules="passwordRules"
                  label="Password"
                  required
                  outlined
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text': 'password'"
                ></v-text-field>
                <v-btn
                  :disabled="!valid"
                  color="info"
                  block
                  class="mr-4"
                  submit
                  @click="submitLogIn"
                >Sign in</v-btn>
              </v-form>

            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>

import axios from 'axios'

export default {
  data () {
    return {
      valid: true,
      show1: false,
      email: '',
      password: '',
      message: '',
      showError: false,
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      passwordRules: [
        v => !!v || "Password is required"
      ],
    }
  },
  beforeMount () {
    if (this.$session.exists()) {
      this.$router.push('/')
    }
  },
  methods: {
    submitLogIn (e) {
      // Prevent form submission.
      e.preventDefault()
      // Submit the login request.
      this.$store.dispatch('doLogIn', {
        email: this.email,
        password: this.password
      }).then((data) => {
        const token = data.token
        if (token.length > 0) {
          // Create a new session and set the JWT token.
          this.$session.start()
          this.$session.set('jwt', token)
          // Set a Bearer token in every API request
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
          // Store the token in session storage.
          sessionStorage['token'] = token
          // Now that the token is set, fetch the session data
          this.$store.dispatch('fetchSession').then((session) => {
            // Set all session data.
            for (let key in session) {
              this.$session.set(key, session[key])
            }
            this.$router.push('/dashboard')
          })
        } else {
          this.message = data.message
          this.showError = true
        }
      })
    }
  }
}
</script>

<style>
</style>
